/* eslint-disable import/extensions */
import modulePermissions from './permissions';

export default {
  namespaced: true,
  modules: {
    permissions: modulePermissions,
  },
};
